import { useQuery } from '@tanstack/react-query';
import API from 'api/API';
import { OrderRecordId } from 'api/models/Orders';
import { QueryKeys } from 'api/models/QueryKeys';

export const useOrder = (orderRecordId?: OrderRecordId) => {
  const query = useQuery({
    queryKey: [QueryKeys.Order, orderRecordId],
    queryFn: async () => (orderRecordId ? await API.orders.getOrder(orderRecordId) : undefined),
    enabled: Boolean(orderRecordId),
  });

  return {
    ...query,
    isLoading: query.isFetching, // the query is only enabled when orderRecordId is defined so technically it's not loading
  };
};
